<template>
  <v-layout wrap align-start>
    <v-flex xs10 md6 lg2>
      <v-select
        id="clients"
        v-model="selected_client"
        :items="[{value: '0', text: 'No Client'}].concat(clients)"
        label="Client"
        item-text="text"
        item-value="value"
        hide-details
        background-color="#282732"
        filled
      >
      </v-select>
    </v-flex>
    <v-flex xs10 md6 lg2>
      <v-select
        id="status"
        v-model="product_status"
        :items="product_status_list"
        label="Product status"
        hide-details
        background-color="#282732"
        filled
        item-text="text"
        @change="change_product_status"
      >
      </v-select>
    </v-flex>
    <v-flex xs10 md6 lg2>
      <v-select
        v-model="selected_product_type"
        :items="product_types"
        eager
        label="Product type"
        hide-details
        background-color="#282732"
        filled
      >
      </v-select>
    </v-flex>
    <v-flex v-if="onPendings" xs10 lg2 >
      <v-select
        v-model="selected_list"
        :items="shown_lists"
        label="List"
        item-text="title"
        item-value="list_id"
        hide-details
        background-color="#282732"
        filled
      >
      </v-select>
    </v-flex>
    <v-flex v-if="onPendings" xs12 md3 lg2>
      <v-select
        v-model="selected_status"
        :items="sync_status"
        label="Status"
        item-text="title"
        item-value="status_id"
        hide-details
        background-color="#282732"
        filled
      >
      </v-select>
    </v-flex>
    <v-flex v-if="onPendings" xs12 md3 lg2>
      <DatepickerRange @return="(value) => requested_dates = value"/>
    </v-flex>
  </v-layout>
</template>

<script>
/* eslint-disable */
import DatepickerRange from '../reusables/datepicker_range.vue';
export default {
  components: { DatepickerRange },
  name: "ClientFilter",
  props: {
    // getSelectedFilters: {
    //   type: Object,
    // },
  },
  data: () => ({
    // statusColor: "rgb(10 255 17 / 37%)",
    // selected_list: '',
    product_status_list: [
      { value: "active", text: "Active Products" },
      { value: "pending", text: "Pending Products" },
    ],
    product_types: [
      { value: "exact", text: "Exact Matching", color: 'brown' },
      { value: "similar", text: "Similar Matching", color: 'blue-grey' },
    ],
  }),
  computed: {
    clients_list () {
      return this.$store.state.productionModule.clients_list;
    },
    clients() {
      return (this.product_status == 'active')
      ? this.clients_list
      : this.clients_list.map((c) => (
        {value: c.value, text: `${c.text} (P: ${c.Pending} - R: ${c.ReCheck})`}
      ))
    },
    statusColor() {
      return (this.product_status == 'active') ? "rgb(10 255 17 / 37%)" : "indigo darken-2"
    },
    selected_client: {
      get() {
        return this.$store.state.productionModule.product_filter.selected_client;
      },
      set( value ) {
        this.$store.commit('productionModule/SET_SELECTED_CLIENT', value);
      }
    },
    product_status: {
      get() {
        return this.$store.state.productionModule.product_filter.product_status;
      },
      set( value ) {
        this.$store.commit('productionModule/SET_PRODUCT_STATUS', value);
      }
    },
    selected_status: {
      get() {
        return this.$store.state.productionModule.product_filter.selected_status;
      },
      set( value ) {
        this.$store.commit('productionModule/SET_SELECTED_STATUS', value);
      }
    },
    selected_product_type: {
      get() {
        return this.$store.state.productionModule.product_filter.product_type
      },
      set ( value ) {
        this.$store.commit('productionModule/SET_SELECTED_PRODUCT_TYPE', value);
      }
    },
    selected_list: {
      get() {
        return this.$store.state.productionModule.product_filter.selected_list;
      },
      set( value ) {
        this.$store.commit('productionModule/SET_SELECTED_LIST', value);
      }
    },
    requested_dates: {
      get() {
        return this.$store.state.productionModule.product_filter.dates;
      },
      set( value ) {
        this.$store.commit('productionModule/SET_DATES', value);
      }
    },
    onPendings () {
      return this.product_status === 'pending';
    },
    lists () {
      return this.$store.state.productionModule.lists;
    },
    shown_lists () {
      if(!!parseInt(this.selected_client)){
        return this.lists.filter(l => l.client_id == parseInt(this.selected_client));
      } else {
        return this.lists;
      }
    },
    sync_status () {
      return this.$store.state.productionModule.sync_status;
    },
  },
  methods: {
    change_product_status() {
      if(this.product_status == 'active'){
        this.selected_status = undefined;
        this.selected_list = undefined;
      }
      if(this.product_status === 'pending'){
        this.selected_status = 0; // pendings as first option
        this.requested_dates = '';
      }
    }
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/production/N_ClientFilter.vue